import moment from 'moment';
import { toast } from 'react-toastify';
import { IScheduleDate } from '../services/common/common.model';
import { Moment } from 'moment';
import { Common } from './constants/common';

export const getPageHeight = () => {
  const header = document.querySelector('.header')?.clientHeight;
  const title = document.querySelector('.title-block')?.clientHeight;
  const tableHeader = document.querySelector('thead')?.offsetHeight;
  const totalHeight = document.body.clientHeight;
  const finalHeight = totalHeight - header - 2 * title - tableHeader - 50;
  return finalHeight;
};

/**
 * Converts date RangePicker filter values ([start, end]) into { start_date, end_date }.
 * The server treats a 2-element array as IN (a, b) but {start_date,end_date} as a range.
 * Returns a new object; the input is not mutated.
 */
export const convertDateRangeFilters = (filterKeys: { [key: string]: any }) => {
  const result: { [key: string]: any } = { ...filterKeys };
  Object.keys(result).forEach((key) => {
    const val = result[key];
    if (val?.length === 2 && typeof val[0] === 'object' && moment(val[0]).isValid()) {
      result[key] = {
        start_date: val[0],
        end_date: val[1],
      };
    }
  });
  return result;
};

// Builds the selection part (filters / keyword / selected ids) of a bulk-update request from
// the values DataTable.getValuesForSelection() produced. Also used for the bulk-impact check,
// so the impact the user confirms is computed from exactly what bulk-update will receive.
export const getBulkSelectionPayload = (
  valuesForSelection: any,
  tableName: string,
  isDummyDropDown?: boolean
) => {
  const Obj: any = {
    ...valuesForSelection,
  };
  const rowList = {
    ...Obj.selectedIds,
  };
  if (Obj.filterKeys) {
    // Convert on a copy so the caller's filter object is never mutated.
    Obj.filterKeys = { ...Obj.filterKeys };
  }
  // Date RangePicker values [m1, m2] become {start_date, end_date} (convertDateRangeFilters
  // returns a new object). Idempotent: DataTable already sends the grid search's converted
  // filters, and objects are left as they are.
  if (isDummyDropDown !== true && Obj.filterKeys) {
    Obj.filterKeys = convertDateRangeFilters(Obj.filterKeys);
  }
  const objectForSelection: any = {
    table_name: tableName,
    filter_keys: Obj.filterKeys,
    is_export_to_excel: false,
    keyword: Obj.keyword,
    limit: Obj.limit,
    offset: Obj.offset,
    order_by: Obj.order_by,
    order_direction: Obj.order_direction,
  };
  if (isDummyDropDown === true) {
    objectForSelection['selectedIds'] = Obj.selectedIds;
  } else {
    rowList.selectedRowList = rowList.selectedRowList?.map((data) => data = data.split('-')[0]);
    objectForSelection['selectedIds'] = rowList.selectedRowList;
  }
  // Typed multi-dataset confirmation (see DataTable bulk-impact guard); the server rejects
  // a bulk-update spanning several datasets with HTTP 409 unless this matches.
  if (Obj.confirm_text) {
    objectForSelection['confirm_text'] = Obj.confirm_text;
  }
  return objectForSelection;
};

export const getObjectForUpdateMultiple = (
  valuesForSelection: any,
  inputValues: any,
  tableName: string,
  isDummyDropDown?: boolean
) => {
  const bu1 = {};
  for (const x in inputValues.checked) {
    if (inputValues.checked[x] === true) {
      bu1[x] = inputValues[x];
    }
  }
  if (Object.keys(bu1).length === 0) {
    toast.error('Please select at least 1 field to update');
    return;
  }
  if (Object.values(bu1).includes(undefined)) {
    Object.keys(bu1).map((data) => {
      if(bu1[data] == undefined) {
        bu1[data] = null;
      }
    })
  }
  const objectForSelection = {
    ...getBulkSelectionPayload(valuesForSelection, tableName, isDummyDropDown),
    update_data: bu1,
    current_user: {},
  };
  return objectForSelection;
};

export const getScheduleDateHelperLookup = (form: any, tableName: string) => {
  let process = {
    company_id: null,
    bu_id: null,
    tenant_id: null,
  };
  process = form;
  const getDataScheduleDate: IScheduleDate = {
    tenant_id: process.tenant_id,
    company_id: process.company_id,
    bu_id: process.bu_id,
    table_name: tableName,
  };
  return getDataScheduleDate;
};

//The Helper Functions are for Date and related thing

export const passDateToApi = (date: Moment | string | Date, isTime?: boolean) => {
  if (date !== null) {
    if (isTime) {
      return moment(date).format(Common.DATETIMEFORMAT);
    } else {
      return moment(date).format(Common.DATEFORMAT);
    }
  } else {
    return null;
  }
};

export const showDateFromApi = (date: Moment | string | Date, isTime?: boolean) => {
  if (date?.toString().includes('T')) {
    if (isTime) {
      return moment(date).utc().format(Common.DATETIMEFORMAT);
    } else {
      return moment(date).utc().format(Common.DATEFORMAT);
    }
  } else {
    if (isTime) {
      return moment(date).local().format(Common.DATETIMEFORMAT);
    } else {
      return moment(date).local().format(Common.DATEFORMAT);
    }
  }
};

export const forEditModal = (date: Moment | string) => {
  if (date?.toString().includes('T')) {
    return moment(date).utc();
  } else {
    return moment(date).local();
  }
};

export const forDropDown = (date: Moment | string) => {
  if (date?.toString().includes('T')) {
    return moment(date).utc().format(Common.DATEFORMAT).toString();
  } else {
    return moment(date).local().format(Common.DATEFORMAT).toString();
  }
};

export const getSimpleDate = (isUTC?: boolean) => {
  if (isUTC === true) {
    return moment().utc();
  } else {
    return moment();
  }
};

export const forDisableDate = () => {
  return (current: Moment) => {
    return current && current > moment().endOf('day');
  };
};

export const getOnlyTime = (date: any) => {
  return moment(date).format('HH:MM:SS').toString();
};

export const getandReturn = (date: any) => {
  return moment(date);
};

// A bulk-import record is only genuinely mapped when currentMapping holds a real
// selection — '' means "a saved mapping exists for the file, but not this sheet",
// which must not count as mapped even though it isn't null.
export const isBulkImportRecordMapped = (record: { currentMapping?: any; excel_to_sql_mapping?: any }) => {
  return (
    record?.currentMapping !== null &&
    record?.currentMapping !== undefined &&
    record?.currentMapping !== '' &&
    record?.excel_to_sql_mapping !== null &&
    record?.excel_to_sql_mapping !== undefined
  );
};
